'use strict';

angular.module('amexReconciliationApp')
  .component('noRole', {
    templateUrl: 'scripts/views/components/no-role.html',
    controller: function(UserModel) {
      var self = this;

      self.isSuperAdmin = UserModel.isSuperAdmin;
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/noRole.js
// module id = 460
// module chunks = 0